import api from '../../../App/socket';

export const resetPartEx = _id => (

    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: { _id },
            update: {
                'part_ex.has_sent_to_crm': false,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/reset_part_ex_request.js